import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { WorkflowTemplateDescriptor } from './model/workflow.template';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';

@Injectable()
export class WorkflowTemplateService extends RESTServiceBase {

  constructor(
    private authService: AuthService,
    private config: AppConfig
  ) {
    super(
      'v1',
      'WorkflowTemplateManagement',
      authService,
      config.WMSConfig
    );

  }

  public create(workflowTemplate: WorkflowTemplateDescriptor): Promise<WorkflowTemplateDescriptor> {
    return super.post<WorkflowTemplateDescriptor>(
      new WorkflowTemplateDescriptor({
        id: undefined,
        href: undefined,

        identifier: workflowTemplate.identifier,
        version: workflowTemplate.version,
        title: workflowTemplate.title,
        primaryResourceTypeName: workflowTemplate.primaryResourceTypeName,
        designerId: workflowTemplate.designerId,
        validFrom: workflowTemplate.validFrom,
        validUntil: workflowTemplate.validUntil,

        modified: workflowTemplate.modified,
        deleted: workflowTemplate.deleted
      }));
  }

  public getWorkflowTemplates(view?: View): Promise<List<WorkflowTemplateDescriptor>> {
    return super.get<List<WorkflowTemplateDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, workflowTemplate: WorkflowTemplateDescriptor): Promise<WorkflowTemplateDescriptor> {
    return super.put<WorkflowTemplateDescriptor>(id, workflowTemplate);
  }

  public getById(id: string): Promise<WorkflowTemplateDescriptor> {
    return super.get<WorkflowTemplateDescriptor>(id);
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/workflow.template/workflow.template.service.ts